import { Badge } from 'foundations-components/transitional/components/Badge';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TITLE_BADGE_TYPES } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function renderBadge(badgeType) {
  if (badgeType === TITLE_BADGE_TYPES.NEW) {
    return /*#__PURE__*/_jsx(Badge, {
      use: "new",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmCards.badges.new"
      })
    });
  }
  if (badgeType === TITLE_BADGE_TYPES.BETA) {
    return /*#__PURE__*/_jsx(Badge, {
      use: "beta",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmCards.badges.beta"
      })
    });
  }
  return null;
}
export function TitleWithBadgeAndTooltip({
  title,
  titleOptions
}) {
  const badge = titleOptions !== null && titleOptions !== void 0 && titleOptions.badgeType ? renderBadge(titleOptions.badgeType) : null;
  const titleContent = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "span",
      children: title
    }), badge && /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      children: badge
    })]
  });
  if (titleOptions !== null && titleOptions !== void 0 && titleOptions.tooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: titleOptions.tooltip,
      children: /*#__PURE__*/_jsx("span", {
        title: typeof titleOptions.tooltip === 'string' ? titleOptions.tooltip : undefined,
        children: titleContent
      })
    });
  }
  return titleContent;
}